// @ts-ignore
import CustomerCalendarApp from './customercalendar/CustomerCalendarApp.svelte';
// @ts-ignore
import JoinMeetingApp from './join/JoinMeetingApp.svelte';
// @ts-ignore
import ParticipantVideoMeetingApp from './videomeeting/participant/ParticipantVideoMeetingApp.svelte';
// @ts-ignore
import SupervisorVideoMeetingApp from './videomeeting/supervisor/SupervisorVideoMeetingApp.svelte';
// @ts-ignore
import SupervisorAdminApp from './admin/supervisors/SupervisorAdminApp.svelte';
// @ts-ignore
import FeedbackApp from './feedback/FeedbackApp.svelte';
// @ts-ignore
import AdminTypesApp from './admintypes/AdminTypesApp.svelte';
// @ts-ignore
import JitsiSettingsApp from './admin/jitsi/JitsiSettingsApp.svelte';
// @ts-ignore
import AdminApp from './admin/AdminApp.svelte';
// @ts-ignore
import MeetingsApp from './meetings/MeetingsApp.svelte';
// @ts-ignore
import EtiquetteApp from './etiquette/EtiquetteApp.svelte';
// @ts-ignore
import InstachatVideoApp from './instachat/InstachatVideoApp.svelte';
// @ts-ignore
import ErrorApp from './error/ErrorApp.svelte';
import { getService } from './customercalendar/store';
import * as addmachine from './meetings/addmachine';
import * as calendarmachine from './meetings/calendarmachine';
import * as store from './meetings/store';
export const startCustomerCalendar = (querySelector, calendar, currentDay) => {
    const service = getService();
    service.send({ type: 'initialize', data: { calendar, currentDay } });
    const app = new CustomerCalendarApp({
        target: document.querySelector(querySelector),
    });
    return app;
};
export function startMeetings(querySelector, options) {
    const findDay = () => {
        return options.calendar.days.find((d) => d.day == options.currentDay);
    };
    const currentDay = findDay();
    const types = options.types;
    const initialType = types.length > 0 ? options.types[0] : undefined;
    console.log({ options });
    if (!options.supervisor_has_category) {
        const app = new ErrorApp({
            target: document.querySelector(querySelector),
            props: {
                message: "Nemonetin pääkäyttäjä ei ole vielä tehnyt sinulle ohjaajakategoriaa. Olethan yhteydessä pääkäyttäjään.",
            },
        });
        return app;
    }
    else if (currentDay && initialType) {
        console.dir({ options, types });
        const calendar = options.calendar;
        const selectedDay = currentDay;
        addmachine.initialize(types, initialType);
        calendarmachine.initialize(calendar);
        store.initialize(calendar, selectedDay);
        const app = new MeetingsApp({
            target: document.querySelector(querySelector),
        });
        return app;
    }
    throw new Error("Current day not found in calendar or no meeting types!");
}
export const startJoinMeeting = (querySelector, options) => {
    const app = new JoinMeetingApp({
        target: document.querySelector(querySelector),
        props: { options },
    });
    return app;
};
export const startSupervisorVideoMeeting = (querySelector, meetingInfo) => {
    const app = new SupervisorVideoMeetingApp({
        target: document.querySelector(querySelector),
        props: {
            clientMeetingInfo: meetingInfo,
        }
    });
    return app;
};
export const startParticipantVideoMeeting = (querySelector, meetingInfo, feedbackUrl) => {
    const app = new ParticipantVideoMeetingApp({
        target: document.querySelector(querySelector),
        props: {
            meetingInfo, feedbackUrl
        }
    });
    return app;
};
export const startFeedback = (querySelector, form) => {
    new FeedbackApp({
        target: document.querySelector(querySelector),
        props: {
            feedbackform: form,
        },
    });
};
export const startAdminTypes = (querySelector, types) => {
    const app = new AdminTypesApp({
        target: document.querySelector(querySelector),
        props: {
            types: types,
        },
    });
    return app;
};
export const startAdmin = (querySelector, settings) => {
    const app = new AdminApp({
        target: document.querySelector(querySelector),
        props: {
            settings
        },
    });
    return app;
};
export const startAdminSupervisors = (querySelector, users) => {
    const app = new SupervisorAdminApp({
        target: document.querySelector(querySelector),
        props: { users },
    });
    return app;
};
export const startAdminJitsi = (querySelector, settings) => {
    const app = new JitsiSettingsApp({
        target: document.querySelector(querySelector),
        props: { settings },
    });
    return app;
};
export function startEtiquette(querySelector, etiquette) {
    const app = new EtiquetteApp({
        target: document.querySelector(querySelector),
        props: { etiquette },
    });
    return app;
}
export function startInstachatVideo(querySelector, props) {
    const app = new InstachatVideoApp({
        target: document.querySelector(querySelector),
        props: Object.assign({}, props)
    });
    return app;
}
